import script from "./ChassisSectionStockVehicle.vue?vue&type=script&setup=true&lang=js"
export * from "./ChassisSectionStockVehicle.vue?vue&type=script&setup=true&lang=js"

import "./ChassisSectionStockVehicle.vue?vue&type=style&index=0&id=4bbbfe9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bbbfe9a"]])

export default __exports__